import axios from 'axios';
import { put, call, takeLeading, delay } from 'redux-saga/effects';
import * as actionTypes from '../actionTypes';
import { api_urls } from '../../utils/api-urls';
import { change_banner_status, create_banner, delete_banner, get_banner, update_banner } from '../../utils/api-routes';
import Swal from "sweetalert2";

function* getBanner() {
    try {
        yield put({ type: actionTypes.SET_IS_LOADING, payload: true });
        const { data } = yield call(axios.get, `${api_urls + get_banner}`);
        console.log("Get Banner Saga Response ::: ", data)

        if (data?.status) {
            yield delay(500);
            yield put({ type: actionTypes.SET_BANNER, payload: data?.results });
        }
        yield put({ type: actionTypes.SET_IS_LOADING, payload: false });
    } catch (error) {
        yield put({ type: actionTypes.SET_IS_LOADING, payload: false });
        console.log("Get Banner Saga Error ::: ", error)
    }
}

function* createBanner(action) {

    try {
        const { payload } = action;
        console.log("Payload ::: ", payload.data)

        const { data } = yield call(axios.post, `${api_urls + create_banner}`, payload?.data);

        if (data?.status) {
            Swal.fire({
                icon: "success",
                text: "Banner Created Successfully",
                showConfirmButton: false,
                timer: 2000,
            });
            yield call(payload?.onComplete)
        }
    } catch (error) {
        Swal.fire({
            icon: "error",
            text: "Failed To Create Banner",
            showConfirmButton: false,
            timer: 2000,
        });
        console.log("Create Banner Saga Error ::: ", error?.response?.data)
    }
}

function* updateBanner(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload)

        const { data } = yield call(axios.post, `${api_urls + update_banner}`, payload?.data);
        console.log("Update Banner Saga Response ::: ", data)

        if (data?.status) {
            Swal.fire({
                icon: "success",
                text: "Banner Updated Successfully",
                showConfirmButton: false,
                timer: 2000,
            });
            yield call(payload?.onComplete)
            yield put({ type: actionTypes.GET_BANNER, payload: null })
        }

    } catch (error) {
        console.log("Update Banner Saga Error ::: ", error?.response?.data)
    }
}

function* deleteBanner(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload)

        const result = yield Swal.fire({
            title: `Are You Sure To Delete`,
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#2A9BAA",
            cancelButtonColor: "red",
            confirmButtonText: "Delete",
        })

        console.log("Result ::: ", result)

        if (result.isConfirmed) {
            const { data } = yield call(axios.post, `${api_urls + delete_banner}`, payload);
            console.log("Delete Banner Saga Response ::: ", data)
            if (data.status) {
                Swal.fire({
                    icon: "success",
                    text: "Banner Deleted Successfully",
                    showConfirmButton: false,
                    timer: 2000,
                });
                yield put({ type: actionTypes.GET_BANNER, payload: null })

            }
        }
    } catch (error) {
        Swal.fire({
            icon: "error",
            text: "Failed To Delete Banner",
            showConfirmButton: false,
            timer: 2000,
        });
        console.log("Delete Banner Saga Error ::: ", error?.response?.data)
    }
}

function* changeBannerStatus(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload)

        const result = yield Swal.fire({
            title: `Are You Sure To Change Status`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#2A9BAA",
            cancelButtonColor: "red",
            confirmButtonText: "Yes",
            cancelButtonText: "No"
        })

        if (result.isConfirmed) {
            const { data } = yield call(axios.post, `${api_urls + change_banner_status}`, payload);
            console.log("Change Status Banner Saga Response ::: ", data)

            if (data?.status) {
                Swal.fire({
                    icon: "success",
                    text: "Status Change Successfully",
                    showConfirmButton: false,
                    timer: 2000,
                });
                yield put({ type: actionTypes.GET_BANNER, payload: null })
            }
        }

    } catch (error) {
        Swal.fire({
            icon: "error",
            text: "Failed To Change Status",
            showConfirmButton: false,
            timer: 2000,
        });
        console.log("Change Status Banner Saga Error ::: ", error?.response?.data)
    }
}

export default function* bannerSaga() {
    yield takeLeading(actionTypes?.GET_BANNER, getBanner);
    yield takeLeading(actionTypes?.CREATE_BANNER, createBanner);
    yield takeLeading(actionTypes?.UPDATE_BANNER, updateBanner);
    yield takeLeading(actionTypes?.DELETE_BANNER, deleteBanner);
    yield takeLeading(actionTypes?.CHANGE_BANNER_STATUS, changeBannerStatus);
}
